module.exports = __webpack_public_path__ + "static/up-arrow-png-20-427be0e2db111ad76292076b765070e1.png";